import React, { useState, useEffect, useRef } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';
import '../pages/AuthPages.css';

const VerifyEmail = () => {
  const [verifying, setVerifying] = useState(true);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');
  const { token } = useParams();
  const attempted = useRef(false);

  useEffect(() => {
    if (!token || attempted.current) return;
    attempted.current = true;
    axios
      .get(`/api/auth/verify-email/${token}`)
      .then(() => {
        setSuccess(true);
        setError('');
      })
      .catch((err) => {
        setError(err.response?.data?.message || 'Verification failed');
        setSuccess(false);
      })
      .finally(() => setVerifying(false));
  }, [token]);

  return (
    <div className="auth">
      <section className="cr-card auth-card">
        <h1>Email Verification</h1>

        {verifying && <p className="cr-muted">Verifying your email</p>}

        {success && (
          <>
            <p className="auth-msg success" role="status">Your email has been successfully verified.</p>
            <Link to="/login" className="cr-btn solid auth-btn">Login to your account</Link>
          </>
        )}

        {error && !success && (
          <>
            <div className="auth-msg error" role="alert">
              <p>{error}</p>
              <p>The verification link may have expired or is invalid.</p>
            </div>
            <Link to="/" className="cr-btn auth-btn">Return to Home</Link>
          </>
        )}
      </section>
    </div>
  );
};

export default VerifyEmail;
